/* eslint-disable react/no-array-index-key */
import FulfilledTitle from '@assets/fulfilled-title.svg';
import UnfulfilledTitle from '@assets/unfulfilled-title.svg';
import {
  PageTitle,
  BottomButtons,
  Panel, PackageCheckboxGroup, CheckBoxItem,
} from '@components';
import { ClaimType } from '@constants';
import { usePackageCheckbox } from './hooks';

import classes from '../choose/index.module.css';

const TextConfig = {
  Title: 'Protected item(s)',
  SubTitle: {
    [ClaimType.Damage]: 'Please choose which item(s) are damaged.',
    [ClaimType.Loss]: 'Please choose which item(s) are lost.',
  },

};

export const CheckPage = () => {
  const {
    fulfilledItems,
    unFulfilledItems,
    orderName,
    type,
    isContinueBtnDisable,
    selectedItems,
    onClickContinue,
    handleChange,
    clearItems,
  } = usePackageCheckbox();

  const getFulfilledBlock = () => {
    if (!fulfilledItems?.length) {
      return null;
    }
    return (
      <Panel icon={FulfilledTitle} title="Fulfilled" className={classes.ful_panel}>
        {
          fulfilledItems.map((packageItem, packageIndex) => (
            <PackageCheckboxGroup
              key={packageItem.fulfilledId + packageIndex}
              orderName={orderName}
              packageItem={packageItem}
              packageIndex={packageIndex}
              selectedItems={selectedItems}
              onChange={handleChange}
              undeliveredAbled={type !== ClaimType.Damage}
            />
          ))
        }
      </Panel>
    );
  };

  const getUnfulfilledBlock = () => {
    if (!unFulfilledItems?.length) {
      return null;
    }
    return (
      <Panel icon={UnfulfilledTitle} title="Unfulfilled" className={classes.unful_panel}>
        {unFulfilledItems.map((item, index) => (
          <CheckBoxItem
            key={item.lineItemId}
            item={item}
            index={index}
            disabled
          />
        ))}
      </Panel>
    );
  };

  return (
    <section className={classes.content}>
      <PageTitle title={TextConfig.Title} subTitle={TextConfig.SubTitle[type]} />
      {getFulfilledBlock()}
      {getUnfulfilledBlock()}
      <BottomButtons
        onClickBack={clearItems}
        isContinueDisabled={isContinueBtnDisable}
        onClickContinue={onClickContinue}
      />
    </section>
  );
};
